import { Component, OnInit } from '@angular/core';
import { UntypedFormGroup } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

import { SnFormFieldConfig } from '@lib/form';
import { t } from '@lib/translation';

@Component({
  selector: 'fs-search-reason-dialog',
  templateUrl: './search-reason-dialog.component.html',
  styleUrls: ['./search-reason-dialog.component.scss'],
})
export class SearchReasonDialogComponent implements OnInit {
  public readonly form = new UntypedFormGroup({});
  public readonly formModel: any = {};
  public readonly formFields: SnFormFieldConfig[] = [
    {
      key: 'search_reason',
      type: 'input',
      templateOptions: {
        label: t('vehicleIntelligence.hotlist.searchReason'),
        required: true,
        minLength: 4,
      },
    },
  ];
  constructor(private readonly _matDialogRef: MatDialogRef<SearchReasonDialogComponent>) {}

  public ngOnInit(): void {}

  public submit(): void {
    this._matDialogRef.close(this.formModel.search_reason);
  }
}
